import { useCurrentModule } from '../ModuleProvider';
import { useAiAnalyzing } from '../../hooks/useAiAnalyzing';
import { getAiBorderMode } from './getAiBorderMode';
export const useAiBorderMode = _ref => {
  let {
    productId,
    fadesUnpickedCards
  } = _ref;
  const module = useCurrentModule();
  const isAnalyzing = useAiAnalyzing();
  const isDeciding = module.SDK.aiRecommendationStore.useIsDeciding();
  const recommendedProductId = module.SDK.aiRecommendationStore.useRecommendedProductId();
  const isRecommendedCard = !!recommendedProductId && recommendedProductId === productId;
  return {
    mode: getAiBorderMode({
      isAnalyzing,
      isDeciding,
      isRecommendedCard,
      fadesUnpickedCards
    }),
    hidesCardBorder: isAnalyzing || isDeciding && isRecommendedCard
  };
};
//# sourceMappingURL=useAiBorderMode.js.map